module.exports = __webpack_public_path__ + "static/images/styles/images/icons/average-rating.268f4b62.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/average-rating.png
// module id = 3631
// module chunks = 11